import React from 'react'
import { FilterComp } from 'react-admin'
import { useFeatureFlag } from 'util/featureFlags'
import SharedFromInput from './filters/SharedFromInput'
import SharedWithInput from './filters/SharedWithInput'

interface PropTypes {
  resource?: string
  children?: React.ReactNode
}

const ShareabilityFilters: React.FC<PropTypes> = (props) => {
  const { children } = props
  const connectedOrgsEnabled = !!useFeatureFlag('connected_orgs', 'on')

  if (!connectedOrgsEnabled && !children) return null
  if (!connectedOrgsEnabled) return <FilterComp {...props}>{children}</FilterComp>
  return (
    <FilterComp {...props}>
      {children}
      <SharedFromInput source="owned_by" label={'Shared From'} />
      <SharedWithInput source="shared_with" label={'Shared With'} />
    </FilterComp>
  )
}

export default ShareabilityFilters
